import axios from "axios";
import Cookies from "js-cookie";

import { logOut } from "../Helper";

const RPD_POLL_PENDING_KEY = 'rpd_poll_pending';

// A 401 means the token is dead -> log out. (RPD polling is the only exception: it deliberately
// polls an endpoint that 401s until the drop completes.) Onboarding out-of-scope calls must come
// back as 403 from the backend, NOT 401 — a 403 is not treated as logout here.
const shouldSkipAuthLogout = () => sessionStorage.getItem(RPD_POLL_PENDING_KEY) === 'true';

export default async function APIService(is_post, url, data, token_type = 'access',is_pan = false) {
    let API_URL = is_pan === true ? process.env.REACT_APP_API_URL2 + url : process.env.REACT_APP_API_URL + url;
    // Onboarding sessions (v2 handoff from mw) carry only an onboarding_token, no access_token.
    // Fall back to it so the KYC-surface calls authenticate unchanged.
    let authToken = sessionStorage.getItem('access_token') || sessionStorage.getItem('onboarding_token');
    if (token_type === 'refresh') {
        authToken = Cookies.get('refreshToken');
    }
  
    if (is_post === true) {
        return await axios
            .post(API_URL, data, {
                headers: {
                    method: "post",
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                timeout: 60000
            })
            .then(function (response) {
                return response.data;
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.data.status_code === 401 && shouldSkipAuthLogout() !== true) {
                        logOut();
                    }
                    return error.response.data;
                } else if (error.request) {
                    return { message: 'Network connection time out', status_code : 504}
                }
            });
    } else {
        return await axios
            .get(API_URL, {
                headers: {
                    method: "get",
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                timeout: 60000
            })
            .then(function (response) {
                return response.data;
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.data.status_code === 401 && shouldSkipAuthLogout() !== true) {
                        logOut();
                    }
                    return error.response.data;
                }
                else if (error.request) {
                    return { message: 'Network connection time out', status_code : 504}
                }
            });
    }
}
